import * as schemaUtils from '@flows/configs/shared/schemaUtils'
import type { StepConfigParams } from '@flows/configs/types'
import type { AnyStepConfiguration } from '@flows/core/types/stepTypes'
import { BaseSchema_PetHealthV1GetsafeDe } from '@flows/insurance/schemas'

const pet_gender = (params: StepConfigParams) =>
  ({
    schema: schemaUtils.generateZodObjectFromPaths({
      [params.helperFunctions.getParamPath('pet_gender')]:
        BaseSchema_PetHealthV1GetsafeDe.shape.pet_gender.unwrap(),
    }),
    stepContent: [
      {
        type: 'title',
        text: {
          type: 'translatableText',
          translationKey: 'sharedFlows_petHealth:steps.pet_gender.title',
          values: {
            pet_name: {
              type: 'dynamicValue',
              path: params.helperFunctions.getParamPath('pet_name'),
            },
          },
        },
      },
      {
        type: 'choice',
        shouldTrackValues: true,
        name: params.helperFunctions.getParamPath('pet_gender'),
        options: [
          {
            value: 'male',
            label: {
              type: 'translatableText',
              translationKey: 'sharedFlows_petHealth:steps.pet_gender.male',
            },
          },
          {
            value: 'female',
            label: {
              type: 'translatableText',
              translationKey: 'sharedFlows_petHealth:steps.pet_gender.female',
            },
          },
        ],
      },
    ],
    subFlow: params.subFlow,
    nextStep: 'pet_neutered',
  }) as const satisfies AnyStepConfiguration

export default pet_gender
